import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeftClick = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M23.4 36C20.2 35.8333 17.5 34.6 15.3 32.3C13.1 30 12 27.2333 12 24C12 20.6667 13.1667 17.8333 15.5 15.5C17.8333 13.1667 20.6667 12 24 12C27.2333 12 30 13.1 32.3 15.3C34.6 17.5 35.8333 20.2 36 23.4L31.8 22.15C31.3667 20.35 30.4333 18.875 29 17.725C27.5667 16.575 25.9 16 24 16C21.8 16 19.9167 16.7833 18.35 18.35C16.7833 19.9167 16 21.8 16 24C16 25.9 16.575 27.5667 17.725 29C18.875 30.4333 20.35 31.3667 22.15 31.8L23.4 36ZM41.05 45L32.5 36.45L30 44L24 24L44 30L36.45 32.5L45 41.05L41.05 45Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgLeftClick);
export default ForwardRef;
